import { configureStore } from '@reduxjs/toolkit'
import sessionSlice from './slices/session.slice'
import cartSlice from './slices/cart.slice'

const store = configureStore({
  reducer: {
    session: sessionSlice,
    cart: cartSlice
  },
})

export default store
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
